/* eslint-disable no-undef */
export const HoursFooter = {
    props: ['results'],
    data() {
      return {
        selectHours: 'sales',
      }
    },
    methods: {
      clicHours:function(data){
        this.selectHours = data
    },
    },
  }